import { render, staticRenderFns } from "./host-cert.vue?vue&type=template&id=9f70e996&scoped=true&"
import script from "./host-cert.vue?vue&type=script&lang=js&"
export * from "./host-cert.vue?vue&type=script&lang=js&"
import style0 from "./host-cert.vue?vue&type=style&index=0&id=9f70e996&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f70e996",
  null
  
)

export default component.exports